// extracted by mini-css-extract-plugin
module.exports = {"commentSeparator":"Thread-module__commentSeparator___r9xQ2","thread":"Thread-module__thread___1At35"};